export default function useCampsiteRating() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const { $gettext } = useGettext();

  /********************
   * REFS & VARS       *
   ********************/
  const suggestedGuestsTranslations = {
    rating_kid_friendly_6: $gettext('Families with children under 6'),
    rating_kid_friendly: $gettext('Families with children under 12'),
    rating_kid_friendly_18: $gettext('Families with children under 18'),
    rating_youth_friendly: $gettext('Youth groups'),
    rating_couple_friendly: $gettext('Couples'),
    rating_senior_friendly: $gettext('Senior citizens'),
    rating_camper_with_tent_friendly: $gettext('Visitors with tents'),
    rating_guests_with_dogs_friendly: $gettext('Visitors with dogs'),
  } as const;
  const suggestedGuestsKeys = Object.keys(suggestedGuestsTranslations) as Array<
    keyof typeof suggestedGuestsTranslations
  >;

  const ratingDetailsTranslations = {
    rating_location: $gettext('Location'),
    rating_infrastructure: $gettext('Pitch & infrastructure'),
    rating_leisure: $gettext('Leisure'),
    rating_catering: $gettext('Catering'),
    rating_friendliness: $gettext('Friendliness'),
    rating_sanitary: $gettext('Sanitary'),
    rating_cleanliness_sanitary: $gettext('Cleanliness sanitary'),
    rating_cleanliness_overall: $gettext('Cleanliness overall'),
    rating_condition_rentable_accommodations: $gettext('Condition rentable accomodations'),
    rating_price_quality_ratio: $gettext('Price-quality ratio'),
    rating_calmness: $gettext('Calmness'),
  } as const;
  const ratingDetailsKeys = Object.keys(ratingDetailsTranslations) as Array<keyof typeof ratingDetailsTranslations>;

  const idealActivitiesTranslations = {
    hiking: $gettext('Hiking'),
    cycling: $gettext('Cycling'),
    mountainbiking: $gettext('Mountainbiking'),
    swimming: $gettext('Swimming'),
    wellness: $gettext('Wellness'),
    kayak: $gettext('Kayak'),
    culture: $gettext('Culture'),
    relaxing: $gettext('Relaxing'),
    sailing: $gettext('Sailing'),
    surfing: $gettext('Surfing'),
    diving: $gettext('Diving'),
    motorboat: $gettext('Motorboat'),
    fishing_bw: $gettext('Fishing'),
    climbing: $gettext('Climbing'),
    paragliding: $gettext('Paragliding'),
    horsebackriding: $gettext('Horsebackriding'),
    tennis: $gettext('Tennis'),
    golf: $gettext('Golf'),
    sightseeing: $gettext('Sightseeing'),
    strolling: $gettext('Strolling'),
    culinary: $gettext('Culinary'),
    motorcycle: $gettext('Motorcycle'),
    party: $gettext('Party'),
    ski: $gettext('Ski'),
    cross_country: $gettext('CrossCountry'),
  } as const;
  const idealActivitiesKeys = Object.keys(idealActivitiesTranslations) as Array<
    keyof typeof idealActivitiesTranslations
  >;

  return {
    idealActivitiesKeys,
    idealActivitiesTranslations,
    ratingDetailsKeys,
    ratingDetailsTranslations,
    suggestedGuestsKeys,
    suggestedGuestsTranslations,
  };
}
